module.exports = __webpack_public_path__ + "static/guitar-hero-1-688cef7769074cf20f151be82202d6d4.jpg";